import { cn } from '@/lib/utils/cn'

import styles from './Spinner.module.css'

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  centered?: boolean
  label?: string
}

export function Spinner({ size = 'md', centered = false, label = 'Loading' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(styles.spinner, styles[size], centered && styles.centered)}
    />
  )
}
